import {
  getAccountingUser,
  getIdfcAccounts,
  getIdfcAuthUrl,
  getUserAccountList,
  getUserPermissionApi,
  idfcBalanceEnquiry,
  idfcRegisterEnquiry,
  idfcSessionLogout,
  unlinkIdfcAccount,
} from "_services";
import { ButtonHeading } from "components";
import { Images } from "constants";
import images from "constants/images";
import { UserContext } from "context";
import useDocumentTitle from "hooks/useDocumentTitle";
import {
  AddExpensesModal,
  AddReceiptVoucherModal,
  AddReciptModal,
  AddTransctionsModal,
  ConnectBankModal,
  TransferModal,
  UpdateIdfcAccountDetailModal,
} from "modals";
import Loading from "pages/Loading";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";
import dashConnect from "../../../assets/img/dashboard-connected-bank.png";
import { FaCheckCircle, FaSync } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import toast from "react-hot-toast";
import { Eye } from "lucide-react";
import idfc_bankImg from "../../../assets/img/idfc_first_bank2.png";
import "./transaction.css";
import { useAccountList } from "hooks";



// Add this helper function at the top of your component file (outside the component)
const getFilteredAccountsList = (data, searchQuery) => {
  if (!data || !data?.sub_category) return [];

  if (!searchQuery || searchQuery.trim() === '') {
    // Return original structure when no search
    return data?.sub_category.map(subCat => ({
      ...subCat,
      accounts: subCat?.accounts
    }));
  }

  const query = searchQuery.toLowerCase().trim();

  // Filter and return sub_categories with their filtered accounts
  return data.sub_category
    .map(subCat => {
      const filteredAccounts = subCat?.accounts?.filter(account => {
        const searchFields = [
          account?.name,
          account?.bank,
          account?.number,
          account?.ifsc,
          account?.code,
          account?.desc,
          subCat?.name
        ];

        return searchFields.some(field =>
          field && field.toString().toLowerCase().includes(query)
        );
      });

      return {
        ...subCat,
        accounts: filteredAccounts
      };
    })
    .filter(subCat => subCat.accounts.length > 0); // Remove empty categories
};

const Transactions = () => {
  const { setUserSettingPermission, userSettingPermission } =
    useContext(UserContext);

  const { accounts, setAccounts, loading, refresh } = useAccountList();

  // const [accounts, setAccounts] = useState("");
  const [show, setShow] = useState(false);
  const [isConnectBankShow, setConnectBankShow] = useState(false);
  const [isUpdateAccountShow, setUpdateAccountShow] = useState(false);
  const [selectedAccount, setSelectAccount] = useState(null);
  const [showExpModal, setShowExpModal] = useState({ title: "", open: false });
  const [dropOpen, setDropOpen] = useState(false);
  const [idfcAccounts, setIdfcAccounts] = useState(false);
  const [isLoadingIdfcAccounts, setIsLoadingIdfcAccounts] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useDocumentTitle("Accounting | T360");
  // const [paramData,setParamData] = useState({
  //   category_id:"",
  //   sub_category_id:"",
  //   account_id:""
  // })

  // onClick={()=>{
  //   setParamData((pre)=>({...pre, category_id: accounts?.id, sub_category_id: i?.id, account_id: k?.id }))
  // } }

  useEffect(() => {
    // getAccountListHandler();
    getUserPermission();
    getIdfcAccountList();
  }, []);

  const callBackFreight = () => {
    // getAccountListHandler();
    refresh();
  };

  const getIdfcAccountList = async () => {
    setIsLoadingIdfcAccounts(true);
    try {
      let param = { company_id: StorageService.getCompanyId() };
      const res = await getIdfcAccounts(param);

      if (res?.responseCode === 200) {
        if (res?.data) {
          setIdfcAccounts(res?.data);
        }
      } else {
        console.error("Submission Error:", res?.error);
      }
    } catch (error) {
      console.error("Submission Error:", error);
    } finally {
      setIsLoadingIdfcAccounts(false);
    }
  };

  const checkAccountStatus = async (acc) => {
    setIsLoading(true);
    try {
      let param = {
        mobileNumber: acc.mobile_number,
        userId: acc.idfc_user_id,
        uniqueRegistrationNumber: acc.referenceNumber,
      };

      const res = await idfcRegisterEnquiry(param);
      if (res?.responseCode === 200) {
        const enquiryStatus = res?.data?.userRegistrationEnquiryResp;
        const status = enquiryStatus?.metaData?.status;

        if (status === "SUCCESS") {
          toast.success(
            status?.metaData?.message || "Your Account has beed Approved."
          );
          getIdfcAccountList();
        } else {
          // Status is ERROR
          toast.error(
            status?.metaData?.message || "User is pending for approval."
          );
        }
      } else {
        toast.error(res?.responseMessage || "Something went wrong.");
      }
    } catch (error) {
      console.error("Submission Error:", error);
    } finally {
      // setSubmitLoading(false);
      setIsLoading(false);
    }
  };
  const deregisterAccount = async (acc) => {
    setIsLoading(true);
    try {
      let param = {
        mobileNumber: acc.mobile_number,
        userId: acc.idfc_user_id,
        uniqueRegistrationNumber: acc.referenceNumber,
      };

      const res = await unlinkIdfcAccount(param);

      if (res?.responseCode === 200) {
        const de_registration = res?.data?.userDeRegistrationResp;
        const status = de_registration?.metaData?.status;

        if (status === "SUCCESS") {
          toast.success(
            de_registration?.metaData?.message ||
            "Account Deregistered successfully."
          );
        } else {
          // Status is ERROR
          toast.error(
            de_registration?.metaData?.message || "DeRegistration failed."
          );
        }
      } else {
        toast.error(res?.responseMessage || "Something went wrong.");
      }
    } catch (error) {
      console.error("Submission Error:", error);
    } finally {
      // setSubmitLoading(false);
      setIsLoading(false);
    }
  };

  const destroySession = async (acc) => {
    setIsLoading(true);
    try {
      let param = {
        referenceNumber: acc.referenceNumber,
        access_token: `Bearer ${acc.auth_token}`,
      };

      const res = await idfcSessionLogout(param);
      getIdfcAccountList();
      if (res?.responseCode == 200) {
        toast.success(res?.message || "Session Logout success");
      } else {
        toast.error(res?.responseMessage || "Something went wrong.");
      }
    } catch (error) {
      console.error("Submission Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getUserPermission = async () => {
    try {
      const res = await getUserPermissionApi({
        company_id: StorageService.getCompanyId(),
      });
      if (res?.responseCode === 200) {
        setUserSettingPermission(res?.data?.user);
      } else {
      }
    } catch (error) {
    }
  };

  // const getAccountListHandler = async () => {
  //   try {
  //     const res = await getAccountingUser({
  //       company_id: StorageService?.getCompanyId(),
  //     });
  //     if (res?.responseCode === 200) {
  //       setAccounts(res?.data?.chart_of_account);
  //     } else {
  //     }
  //   } catch (error) {
  //   }
  // };

  const getAuthUrl = async (item) => {
    try {
      let param = {
        referenceNumber: item.referenceNumber,
      };
      const res = await getIdfcAuthUrl(param); // call your API

      if (res?.responseCode === 200 && res?.data?.authURL) {
        return res.data.authURL;
      } else {
        toast.error("Something went wrong.");
        return null;
      }
    } catch (error) {
      console.error("Submission Error:", error);
      return null;
    }
  };

  const fetchBalance = async (item, forceToAuth) => {
    const isTokenValid = () => {
      if (!item?.auth_token || !item?.auth_token_expires_at) return false;

      const expiresAt = new Date(item.auth_token_expires_at).getTime();
      const now = Date.now();

      const FIVE_MIN = 5 * 60 * 1000;
      return expiresAt - now > FIVE_MIN;
    };

    if (!isTokenValid() || forceToAuth) {
      const url = await getAuthUrl(item);

      const handleMessage = (event) => {
        const { responseCode, data } = event.data || {};

        if (responseCode === 200 && data?.auth_token) {
          fetchBalanceWithToken(item, data.auth_token, data);

          window.removeEventListener("message", handleMessage);
          if (popup && !popup.closed) popup.close();
        }
      };

      window.addEventListener("message", handleMessage);

      const popup = window.open(url, "BankLogin", "width=600,height=600");
    } else {
      fetchBalanceWithToken(item, item?.auth_token);
    }
  };

  const fetchBalanceWithToken = async (item, token, data) => {
    setIsLoading(true);
    try {
      const param = {
        accountNumber: item?.account_number,
        access_token: `Bearer ${token}`,
        referenceNumber: item?.referenceNumber,
      };

      const res = await idfcBalanceEnquiry(param);

      if (res?.data?.code == "402" || res?.responseCode == 500) {
        fetchBalance(item, true);
        return;
      }

      if (res?.responseCode === 200 && res?.data) {
        const { metaData, resourceData } = res?.data?.prefetchAccountResp || {};

        if (metaData?.status === "SUCCESS" && resourceData) {
          const balance = resourceData?.availableBalance;

          setIdfcAccounts((prev) =>
            prev.map((acc) =>
              acc.account_number == item?.referenceNumber
                ? {
                  ...acc,
                  availableBalance: balance,
                  isBalanceFetched: true,
                  auth_token: data?.auth_token || token,
                  auth_token_expires_at:
                    data?.auth_token_expires_at ||
                    item?.auth_token_expires_at,
                  auth_token_generated_at:
                    data?.auth_token_generated_at ||
                    item?.auth_token_generated_at,
                  auth_token_updated_at:
                    data?.auth_token_updated_at ||
                    item?.auth_token_updated_at,
                }
                : acc
            )
          );

          setAccounts((prev) => ({
            ...prev,
            sub_category: prev.sub_category.map((sub) =>
              sub.id == 27
                ? {
                  ...sub,
                  accounts: sub.accounts.map((acc) =>
                    acc.cb_data?.referenceNumber == item?.referenceNumber
                      ? {
                        ...acc,
                        cb_data: {
                          ...acc.cb_data,
                          availableBalance: balance,
                          isBalanceFetched: true,
                          auth_token: data?.auth_token || token,
                          auth_token_expires_at:
                            data?.auth_token_expires_at ||
                            item?.auth_token_expires_at,
                          auth_token_generated_at:
                            data?.auth_token_generated_at ||
                            item?.auth_token_generated_at,
                          auth_token_updated_at:
                            data?.auth_token_updated_at ||
                            item?.auth_token_updated_at,
                        },
                      }
                      : acc
                  ),
                }
                : sub
            ),
          }));

          toast.success(`Account Balance: ₹ ${balance}`);
          return balance;
        } else if (metaData?.status === "ERROR") {
          toast.error(metaData.message);
          return null;
        }
      } else {
        if (res?.data?.code === "402") {
          getAuthUrl(item, true);
        } else {
          // toast.error("Something went wrong.");
        }
        return null;
      }
    } catch (error) {
      // console.error("Balance error:", error);
      return null;
    } finally {
      setIsLoading(false);
    }
  };


  const filteredAccounts = React.useMemo(() => {
  if (!accounts) return null;

  let result = accounts;

  // Step 1: Apply search filter
  if (searchQuery && searchQuery.trim() !== '') {
    const filtered = getFilteredAccountsList(accounts, searchQuery);
    result = {
      ...accounts,
      sub_category: filtered
    };
  }

  // Step 2: Sort all accounts A to Z by name (AUTOMATIC)
  result = {
    ...result,
    sub_category: result?.sub_category?.map(subCat => ({
      ...subCat,
      accounts: [...subCat?.accounts].sort((a, b) => {
        const nameA = (a?.name || '').toLowerCase();
        const nameB = (b?.name || '').toLowerCase();
        return nameA?.localeCompare(nameB); // A to Z sorting
      })
    }))
  };

  return result;
}, [accounts, searchQuery]);

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  let AddTransactionAccountModal = {
    isOpen: show,
    closeModal: (e) => setShow(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Add Account ",
    // headerPart: true,
    footerPart: true,
    submitTitle: "Add Account",
    // getAccountListHandler: getAccountListHandler,
    getAccountListHandler: refresh,
  };

  let AddExpensesModals = {
    isOpen: showExpModal.open,
    closeModal: (e) =>
      setShowExpModal((pre) => ({ ...pre, title: "", open: false })),
    modalMainClass: "_dashCommon_Modal _addExpModal",
    modalTitle: "General Expenses",
    headerPart: false,
    footerPart: true,
    sendApprovalButtonTitle: "Send for Approval",
    submitTitle: "Add General Expense",
    cancelButtonTitle: "Cancel",
    callBackFreight: callBackFreight,
    userSettingPermission: userSettingPermission,
  };

  let AddReciptVoucherModalsProps = {
    isOpen: showExpModal.open,
    closeModal: (e) =>
      setShowExpModal((pre) => ({ ...pre, title: "", open: false })),
    modalMainClass: "_dashCommon_Modal _addExpModal",
    modalTitle: "General Receipt",
    headerPart: false,
    footerPart: true,
    sendApprovalButtonTitle: "Send for Approval",
    submitTitle: "Add General Receipt",
    cancelButtonTitle: "Cancel",
    callBackFreight: callBackFreight,
    userSettingPermission: userSettingPermission,
  };

  let reciptModalsSchema = {
    isOpen: showExpModal.open,
    closeModal: (e) =>
      setShowExpModal((pre) => ({ ...pre, title: "", open: false })),
    modalMainClass: "_dashCommon_Modal _addExpModal",
    modalTitle: "General Recipt",
    headerPart: false,
    footerPart: true,
    cancelButtonTitle: "Send for Approval", // show only send approval , expenses_approval === 1 , hide add general recipt
    submitTitle: "Add General Recipt", // show both expenses_approval === 0
    callBackFreight: callBackFreight,
    // getAccountListHandler: getAccountListHandler
  };

  let transferModalsSchema = {
    isOpen: showExpModal.open,
    closeModal: (e) =>
      setShowExpModal((pre) => ({ ...pre, title: "", open: false })),
    modalMainClass: "_dashCommon_Modal _addExpModal",
    modalTitle: "Fund Transfer",
    headerPart: false,
    footerPart: true,
    cancelButtonTitle: "Cancle",
    submitTitle: "Fund Transfer",
    callBackFreight: callBackFreight,
    // getAccountListHandler: getAccountListHandler
  };


  return (
    <>
      {isLoading && (
        <div
          class="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100 text-white"
          style={{ zIndex: 1000, background: "rgba(0,0,0,0.8)" }}
        >
          <div>...Please wait</div>
        </div>
      )}
      <ButtonHeading
        onClick={() => setShow(!show)}
        connnectBankOnClick={() => setConnectBankShow(!isConnectBankShow)}
        connnectBankButton={true}
        title={"Accounting"}
        buttonTitle="Add Account"
        Expenses={true}
        expenseOnClick={setShowExpModal}
        userSettingPermission={userSettingPermission}
      />

      <div className="__accountMain_bxs">
        <div className="__connectDetail_otr">
          <div className="div" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}><h4>Connected Banking (CB)</h4>
            <div className="_inpW_search _lrl_inpSrch" style={{ marginRight: "10px" }}>
              <svg
                className="srcIcon"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <path
                  opacity="0.2"
                  d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z"
                  fill="black"
                />
              </svg>
              <input
                type="text"
                placeholder="Search"
                className="simpleFilter_input"
                name="search"
                value={searchQuery}
                onChange={handleSearchChange}
              />

            </div></div>

          {isLoadingIdfcAccounts ? (
            <p className="p-3"> Loading... </p>
          ) : idfcAccounts?.length > 0 ? (
            <div className="container-fluid">
              <div className="row cashInHnad_s">
                {idfcAccounts?.map((item) => {
                  return (
                    <div
                      className="col-md-6 col-lg-5 col-xl-5"
                      key={`${item._id}`}
                    >
                      <div className="branch_inner">
                        <div className="branch_left">
                          <div>
                            <h6>IDFC First Bank</h6>
                            <span className="__accNumber">
                              {item.account_name}
                            </span>
                            <span className="__accNumber">
                              {item.account_number}
                            </span>
                            <p
                              className={`__accStatus  ${item.status == 1
                                ? "__accActive_sts"
                                : "__accActive_sts"
                                }`}
                            >
                              <span></span>{" "}
                              {item?.status == 1
                                ? "Active"
                                : item?.status == 0
                                  ? "Pending"
                                  : ""}
                            </p>
                          </div>

                          <div className="__trcPrice_bar">
                            {item.status == 0 ? (
                              <FaSync
                                className="mx-1"
                                onClick={() => checkAccountStatus(item)}
                              />
                            ) : (
                              <p>
                                <span className={false ? "_minus₹" : "_plus₹"}>
                                  {item?.availableBalance &&
                                    item?.isBalanceFetched ? (
                                    <>
                                      ₹
                                      {Number(item?.availableBalance).toFixed(
                                        2
                                      )}
                                      <FaSync
                                        className="mx-1"
                                        onClick={() =>
                                          fetchBalanceWithToken(
                                            item,
                                            item?.auth_token
                                          )
                                        }
                                      />{" "}
                                    </>
                                  ) : (
                                    <Eye onClick={() => fetchBalance(item)} />
                                  )}
                                </span>
                              </p>
                            )}

                            {item.status == 1 && (
                              <div
                                className="dropdown ml-2"
                                onMouseEnter={() => setDropOpen(true)}
                                onMouseLeave={() => setDropOpen(false)}
                              >
                                <button
                                  className="dropdown-toggle"
                                  type="button"
                                >
                                  <BsThreeDotsVertical />
                                </button>
                                <ul
                                  className={`dropdown-menu ${dropOpen ? "show" : ""
                                    }`}
                                >
                                  <li
                                    onClick={() => {
                                      setUpdateAccountShow(true);
                                      setSelectAccount(item);
                                    }}
                                  >
                                    <a className="dropdown-item px-2">
                                      Edit Account
                                    </a>
                                  </li>
                                  {item?.status == 1 && (
                                    <li onClick={() => deregisterAccount(item)}>
                                      <a className="dropdown-item px-2">
                                        Unlink Account
                                      </a>
                                    </li>
                                  )}
                                  <li>
                                    <a className="dropdown-item px-2">
                                      View Account
                                    </a>
                                  </li>
                                  {item?.auth_token &&
                                    item?.auth_token != "" && (
                                      <li onClick={() => destroySession(item)}>
                                        <a className="dropdown-item px-2">
                                          Log out
                                        </a>
                                      </li>
                                    )}
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="branch_right">
                          <img src={idfc_bankImg} alt="IDFC First Bank" />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="__connectDetail_bxs">
              <div>
                <h6>Connect your bank account in a minute</h6>

                <ul>
                  <li>
                    <FaCheckCircle />{" "}
                    <span>
                      Pay your vendors or outstanding bills directly from your
                      bank account
                    </span>
                  </li>
                  <li>
                    <FaCheckCircle />{" "}
                    <span>
                      Fetch your bank statement and be book-keeping ready
                    </span>
                  </li>
                </ul>
              </div>
              <div>
                <img src={dashConnect} alt="" />
              </div>
            </div>
          )}
        </div>

        {filteredAccounts ? (
          <div className="_trancMain_bx">
            {searchQuery && filteredAccounts.sub_category?.length === 0 && (
              <div className="text-center py-5">
                <p>No accounts found matching "{searchQuery}"</p>
              </div>
            )}
            {filteredAccounts?.sub_category?.map((i, index) => {
              console.log(i)
              return (
                <div className="container-fluid" key={`${i.id}_${i?.name}`}>
                  <h4 className="_trancHead">{i?.name}</h4>

                  <div className="row cashInHnad_s">
                    {i?.accounts?.map((k) => {
                      return (
                        <React.Fragment>
                          {k?.cb_account_type == 1 && k?.cb_data ? (
                            <div
                              className="col-md-6 col-lg-4 col-xl-3"
                              key={`${i.id}_${i?.name}_${k?.name}`}
                            >
                              <div className="branch_inner">
                                <div className="branch_left">
                                  <div>
                                    <h6>IDFC First Bank</h6>
                                    <span className="__accNumber">
                                      {k?.cb_data?.account_name}
                                    </span>
                                    <span className="__accNumber">
                                      {k?.cb_data?.account_number}
                                    </span>
                                    <p
                                      className={`__accStatus  ${k?.cb_data?.status == 1
                                        ? "__accActive_sts"
                                        : "__accActive_sts"
                                        }`}
                                    >
                                      <span></span>{" "}
                                      {k?.cb_data?.status == 1
                                        ? "Active"
                                        : k?.cb_data?.status == 0
                                          ? "Pending"
                                          : ""}
                                    </p>
                                  </div>

                                  <div className="__trcPrice_bar">
                                    {k?.cb_data?.status == 0 ? (
                                      <FaSync
                                        className="mx-1"
                                        onClick={() =>
                                          checkAccountStatus(k?.cb_data)
                                        }
                                      />
                                    ) : (
                                      <p>
                                        <span
                                          className={
                                            false ? "_minus₹" : "_plus₹"
                                          }
                                        >
                                          {k?.cb_data?.availableBalance &&
                                            k?.cb_data?.isBalanceFetched ? (
                                            <>
                                              ₹
                                              {Number(
                                                k?.cb_data?.availableBalance
                                              ).toFixed(2)}
                                              <FaSync
                                                className="mx-1"
                                                onClick={() =>
                                                  fetchBalanceWithToken(
                                                    k?.cb_data,
                                                    k?.cb_data?.auth_token
                                                  )
                                                }
                                              />{" "}
                                            </>
                                          ) : (
                                            <Eye
                                              onClick={() =>
                                                fetchBalance(k?.cb_data)
                                              }
                                            />
                                          )}
                                        </span>
                                      </p>
                                    )}

                                    {k?.cb_data?.status == 1 && (
                                      <div
                                        className="dropdown ml-2"
                                        onMouseEnter={() => setDropOpen(true)}
                                        onMouseLeave={() => setDropOpen(false)}
                                      >
                                        <button
                                          className="dropdown-toggle"
                                          type="button"
                                        >
                                          <BsThreeDotsVertical />
                                        </button>
                                        <ul
                                          className={`dropdown-menu ${dropOpen ? "show" : ""
                                            }`}
                                        >
                                          <li
                                            onClick={() => {
                                              setUpdateAccountShow(true);
                                              setSelectAccount(k?.cb_data);
                                            }}
                                          >
                                            <a className="dropdown-item px-2">
                                              Edit Account
                                            </a>
                                          </li>
                                          {k?.cb_data?.status == 1 && (
                                            <li
                                              onClick={() =>
                                                deregisterAccount(k?.cb_data)
                                              }
                                            >
                                              <a className="dropdown-item px-2">
                                                Unlink Account
                                              </a>
                                            </li>
                                          )}
                                          <li>
                                            <a className="dropdown-item px-2">
                                              View Account
                                            </a>
                                          </li>
                                          {k?.cb_data?.auth_token &&
                                            k?.cb_data?.auth_token != "" && (
                                              <li
                                                onClick={() =>
                                                  destroySession(k?.cb_data)
                                                }
                                              >
                                                <a className="dropdown-item px-2">
                                                  Log out
                                                </a>
                                              </li>
                                            )}
                                        </ul>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="branch_right">
                                  <img
                                    src={idfc_bankImg}
                                    alt="IDFC First Bank"
                                  />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div
                              className="col-md-6 col-lg-4 col-xl-3"
                              key={`${i.id}_${i?.name}_${k?.name}`}
                            >
                              <Link
                                to={i.id != 28 ? "/accounting/transactions/bank_transaction_list" : "/accounting/transactions/paynow_transaction"}
                                className="branch_inner"
                                state={{
                                  data: {
                                    category_id: accounts?.id,
                                    sub_category_id: i?.id,
                                    account_id: k?._id,
                                  },
                                }}
                              >
                                <div className="branch_left">
                                  <div>
                                    <h6>{k?.name}</h6>
                                    <span className="__accNumber">
                                      {k?.number ? `${'X'.repeat(4)}${k.number.toString().slice(-4)}` : null}
                                    </span>
                                    <p className="__accStatus  __accActive_sts">
                                      <span></span> Active
                                    </p>
                                  </div>

                                  <div className="__trcPrice_bar">
                                    <p>
                                      <span
                                        className={
                                          k?.balance < 0 ? "_minus₹" : "_plus₹"
                                        }
                                      >{`₹ ${isNaN(Number(k?.balance)) ? '0.00' : Number(k?.balance).toFixed(2)}`}</span>
                                    </p>
                                  </div>
                                </div>
                                <div className="branch_right">
                                  <img
                                    src={
                                      i?.name == "Bank"
                                        ? images.BANK_ICON.default
                                        : i?.name == "Cash"
                                          ? images.RP_WALLET.default
                                          : images.OTHER_TRANS_ICON.default
                                    }
                                    alt=""
                                  />
                                </div>
                              </Link>
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}


                  </div>
                </div>
              );
            })}

            <div
              className={`offcanvas offcanvas-end common_offCanvas ${isConnectBankShow ? "show" : ""
                }`}
              tabIndex={-1}
              style={{ visibility: isConnectBankShow ? "visible" : "hidden" }}
            >
              {isConnectBankShow && (
                <ConnectBankModal
                  isOpen={isConnectBankShow}
                  onClose={() => setConnectBankShow(false)}
                  getIdfcAccountList={getIdfcAccountList}
                />
              )}
            </div>
            <div className={isConnectBankShow ? "offBack_drop" : ""}></div>

            <div
              className={`offcanvas offcanvas-end common_offCanvas ${isUpdateAccountShow ? "show" : ""
                }`}
              tabIndex={-1}
              style={{ visibility: isUpdateAccountShow ? "visible" : "hidden" }}
            >
              <UpdateIdfcAccountDetailModal
                isOpen={isUpdateAccountShow}
                onClose={() => setUpdateAccountShow(false)}
                getIdfcAccountList={getIdfcAccountList}
                selectedAccount={selectedAccount}
              />
            </div>
            <div className={isUpdateAccountShow ? "offBack_drop" : ""}></div>

            {show && (
              // <AddChartAccountModal {...AddTransactionAccountModal} />
              <AddTransctionsModal {...AddTransactionAccountModal} />
            )}

            {showExpModal.title == "expense" && (
              <AddExpensesModal {...AddExpensesModals} />
            )}

            {showExpModal.title == "receipt" && (
              <AddReciptModal {...reciptModalsSchema} />
            )}

            {showExpModal.title == "general_receipt" && (
              <AddReceiptVoucherModal {...AddReciptVoucherModalsProps} />
            )}

            {showExpModal.title == "transfer" && (
              <TransferModal {...transferModalsSchema} />
            )}
          </div>
        ) : (
          <div
            colSpan="100%"
            className="loaderBg"
            style={{ textAlign: "center" }}
          >
            <Loading />
          </div>
        )}
      </div>
    </>
  );
};

export default Transactions;


